import * as React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import MDInput from "components/MDInput";
import { useState } from "react";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";
import { updateCatalog } from "rest/requests";
import swal from "sweetalert";
import CommonSelect from "components/CommonSelect/select";
import { createCatalog } from "rest/requests";

function editCatalog(newName, newAbbrev, originalCatalog, setIsEditingCatalog) {
  console.log("Editing...");
  const body = {
    name: newName,
    abbreviation: newAbbrev,
    catalogTypeId: originalCatalog.catalogTypeId,
    id: originalCatalog.id,
    filteredL1: [],
    filteredL2: [],
  };
  updateCatalog(body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Catalogo actualizado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
    });
  setIsEditingCatalog(false);
}

function addCatalog(name, abbreviation, catalogTypeId, setIsEditingCatalog) {
  console.log("Adding...");
  const body = {
    name: name,
    abbreviation: abbreviation,
    catalogTypeId: catalogTypeId,
    filteredL1: [],
    filteredL2: [],
  };
  createCatalog(body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Catalogo creado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
    });
  setIsEditingCatalog(false);
}

function EditCatalogs({ catalogToEdit, setIsEditingCatalog, catalogsTypeList }) {
  const [name, setName] = useState(catalogToEdit ? catalogToEdit.name : "");
  const [abbreviation, setAbbreviation] = useState(catalogToEdit ? catalogToEdit.abbreviation : "");
  const [selectedCatalogId, setSelectedCatalogId] = useState(null);

  return (
    <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Nombre"
            value={name}
            fullWidth={true}
            onChange={(event) => setName(event.target.value)}
            success={name != ""}
            error={name === ""}
          />
        </Grid>
      </Grid>
      <Grid container marginTop={2}>
        <Grid item sm={6} xs={12}>
          <MDInput
            variant="outlined"
            type="text"
            label="Abreviatura"
            value={abbreviation}
            fullWidth={true}
            onChange={(event) => setAbbreviation(event.target.value)}
            success={abbreviation != ""}
            error={abbreviation === ""}
          />
        </Grid>
      </Grid>
      {catalogToEdit === null ? (
        <Grid container marginTop={2}>
          <Grid item sm={6}>
            <CommonSelect
              data={catalogsTypeList}
              onChange={(selectedValue) => setSelectedCatalogId(selectedValue)}
              label={"Seleccione el tipo de catálogo"}
            ></CommonSelect>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      <Divider></Divider>

      <Grid container marginTop={2}>
        <Grid item padding={2}>
          <MDButton variant="outlined" color="info" onClick={() => setIsEditingCatalog(false)}>
            Atras
          </MDButton>
        </Grid>

        <Grid item padding={2}>
          {catalogToEdit ? (
            <MDButton
              variant="contained"
              color="info"
              onClick={() => editCatalog(name, abbreviation, catalogToEdit, setIsEditingCatalog)}
            >
              Actualizar
            </MDButton>
          ) : (
            <MDButton
              variant="contained"
              color="info"
              onClick={() => addCatalog(name, abbreviation, selectedCatalogId, setIsEditingCatalog)}
            >
              Crear
            </MDButton>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default EditCatalogs;

EditCatalogs.defaultProps = {
  catalogToEdit: null,
  setIsEditingCatalog: null,
  catalogsTypeList: [],
};

EditCatalogs.propTypes = {
  catalogToEdit: PropTypes.object,
  setIsEditingCatalog: PropTypes.func,
  catalogsTypeList: PropTypes.array,
};
